<p>
  purchase-error works!
</p>
